export const LOCAL_STORAGE_KEY = {
  USER_CREDENTIALS: 'ngx-webstorage|session.user'
};

export const LANGUAGES = {
  EN: {
    CODE: 'en'
  },
  EN_IE: {
    CODE: 'en-ie'
  },
  EL: {
    CODE: 'el'
  },
  EL_CY: {
    CODE: 'el-cy'
  }
};

export enum LANGUAGE_CODES {
  EN = 'en',
  EN_IE = 'en-ie',
  EL = 'el',
  EL_CY = 'el-cy'
}

export enum PAYMENT_BANK {
  // Extend this ENUM if needed...
  STRIPE = 'stripe',
  STRIPE_UNATTENDED = 'stripe_unattended',
  SEPA = 'sepa',
  BANK = 'bank'
}

export const isDevelopment = process.env.NODE_ENV !== 'production';

// Would be "true" for production and production.stage and testing env
export const isProduction = process.env.NODE_ENV === 'production';

// Would be "true" ONLY for production
export const isRealProduction = process.env.REAL_ENV === 'production';
